import { PillButton } from "@/components/marketing/PillButton";
import { Logo } from "@/components/marketing/Logo";

export default function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-oath-bg px-6">
      <div className="text-center">
        <div className="flex justify-center"><Logo /></div>
        <p className="mt-10 font-mono-label text-[11px] text-oath-accent">ERROR · 404</p>
        <h1 className="mt-4 font-display text-5xl font-bold tracking-tight text-oath-ink">
          Page not found
        </h1>
        <p className="mt-4 text-oath-secondary">This page could not be verified in our records.</p>
        <div className="mt-8 flex justify-center">
          <PillButton to="/" variant="dark">BACK TO HOME</PillButton>
        </div>
      </div>
    </div>
  );
}
